import * as React from 'react';
import Swatch, { SwatchProps } from './Swatch';
import '../../styles/components/swatches-group.scss';
import SizeGuide from "./SizeGuide"

export type SwatchesTypes = 'default' | 'colour';

interface SwatchesGroupProps {
    swatches: SwatchProps[];
    option: string;
    index?: number;
    type?: SwatchesTypes
    onSwatchSelected?: (index: number, value: string) => void
}

const SwatchesGroup = (props: SwatchesGroupProps) => {
    const { index, type, onSwatchSelected } = props;
    const handleOnSwatchSelected = (value: string) => {
        if (onSwatchSelected && index !== undefined)
            onSwatchSelected(index, value);
    }
    const title = props.option;
    return (
        <>
            <div className={ `swatches-group ${type == 'colour' ? 'swatches-group--colour' : ''}`}>
                <h2 className="swatches-group__title h6">{ title }</h2>
                <div className="swatches">
                    { props.swatches.map((swatch: SwatchProps, index:number) => {
                        return (<Swatch key={ `${swatch.value}${index}` } index={index} onSwatchSelected={handleOnSwatchSelected} {...swatch}></Swatch>)
                    })}
                    {title && title.toLowerCase() === 'size' && <SizeGuide />}
                </div>
            </div>
        </>
    );
}
export default SwatchesGroup;
